const i = Object.freeze({
  // Setting defaultContainer to false appends it to the target parent
  container: !1,
  // Sets the DOM element defining the boundaries of the element
  boundary: document.body,
  // Default tooltip placement relative to target element
  placement: "right",
  // Close tooltip on click on tooltip target
  hideTriggers: (e) => [...e, "click"],
  // Delay (ms)
  delay: {
    show: 100,
    hide: 0
  },
  // Update popper on content resize
  handleResize: !0,
  // Skidding (slide along the target)
  skidding: 0,
  // Offset (move toward or away from target)
  distance: 0,
  autoHide: !1
});
function n(e, o) {
  return {
    ...i,
    ...e,
    popperTriggers: o ? ["hover"] : [],
    // Remove props meant only for the tooltip-layout component
    onOpen: void 0,
    onClose: void 0,
    modelValue: void 0,
    // Disable props which are handled by tooltip-layout.
    // Using these would work for desktop but break on the mobile dialog
    onShow: void 0,
    onAutoHide: void 0
  };
}
export {
  n as getFloatingVueOptions
};
//# sourceMappingURL=floating-vue-options.js.map
